<template>
    <v-container fluid>
      <v-flex>
        <v-card :disabled="!editMode" min-height="350" >
          <v-card-title>
            Créditos en mora
          </v-card-title>
          <v-card-text :disabled="!editMode">
                <v-layout :disabled="!editMode">
                  <v-data-table 
                    :headers="headers" dense
                    :loading="loading"
                    :items="listaCreditos"
                    v-model="selectedRow"
                  >
                  <template slot="no-data">
                      <v-alert :value="true" color="grey" icon="warning">
                      No se encontraron créditos.
                      </v-alert>
                  </template>
                  <template v-slot:item="{ item }">                 

                    <tr :color="item.statusMoraColor">
                        <td><app-acciones-comunes :personaId="personaId" > </app-acciones-comunes></td>
                        <td class="text-xs-left caption">{{ item.canalVenta }}</td>
                        <td class="text-xs-left caption">{{ item.numero }}</td>
                        <td class="text-xs-left caption">{{ item.atraso }}</td>
                        <td class="text-xs-left caption" v-if="item.fechaUltimoPago">{{ item.fechaUltimoPago | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}}</td>
                        <td class="text-xs-left caption" v-else>-</td>
                        <td class="text-xs-left caption">{{ item.saldoVencido | currency}}</td>                                                
                      </tr>                      
                  </template>
                  </v-data-table>
              </v-layout>             
            </v-card-text>
        </v-card>
      </v-flex>
    </v-container>
</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    editMode: true,
    loading: false,
    totalItems: 0, // va afuera de pagination
    headers: [ // definición de columnas
        { text: '', value: 'accion', width:40, sortable:false },
        { text: 'Origen', value: 'origen', width:200},
        { text: 'Número', value: 'numero'},
        { text: 'VA', value: 'atraso', width:40},
        { text: 'Ult.Pago', value: 'fechaUltimoPago'},
        { text: 'Deuda Vencida', value: 'deuda'}
        //{ text: 'Mora', value: 'statusMora'}
      ],
    listaCreditos: [], // registros
    selectedRow: []
  }),
  props: ['personaId'],
  watch:{
    'personaId': function(personaId){
        Vue.$log.debug('editMode' + personaId);          
        this.loadCreditos(personaId);
    }
  },
  computed: {  
  },
  created () {
    if(this.personaId)
      this.loadCreditos(this.personaId);
  },
  methods: {
    ...mapMutations(['alertError']),
    ...mapActions(['']),
    async loadCreditos(personaId){
      this.loading = true;
      this.emitLoading(true);
      try{
        var result= await http.get('creditos/listenmoraporpersona?personaId='+ personaId);

        this.listaCreditos = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
      this.emitLoading(false);
    },
    emitLoading (value) {
      this.$emit('loading-changed', value)
    }
  },
  
}

</script>